<div [ngStyle]="{ height: '100%' }" fxLayout="column">
  <div fxFlex="100%" class="u-overflow-auto u-showScrollBar u-padding-24">
    <p
      class="u-marginBottom-16"
      i18n="@@hubConfigSegmentationDialog.description"
    >
      Help your members understand what interests are and their benefits
    </p>
    <mat-form-field class="mat-form-field-width-100 u-marginBottom-16">
      <mat-label i18n="@@hubConfigSegmentationDialog.segmentDescriptionLabel">
        Description</mat-label
      >
      <textarea
        matInput
        cdkTextareaAutosize
        cdkAutosizeMinRows="2"
        [formControl]="categoryDescriptionForm"
        [maxlength]="maxDescriptionLength"
      >
      </textarea>
      <mat-hint align="end">
        {{ categoryDescriptionForm.value?.length || 0 }}/{{
          maxDescriptionLength
        }}
      </mat-hint>
    </mat-form-field>
    <div
      fxLayout="row"
      fxLayoutAlign="start start"
      fxLayoutGap="4px"
      class="color-grey-300 text-caption"
    >
      <mat-icon class="md-16 u-marginBottom-16">info_outline</mat-icon>
      <p i18n="@@hubConfigSegmentationDialog.tip">
        This description will be shown to the member during onboarding.
      </p>
    </div>
  </div>
  <div
    class="u-padding-8-0 u-padding-0-16 u-borderTop-grey100"
    fxFlex="0 0 auto"
    fxLayoutAlign="end center"
    fxLayoutGap="8px"
  >
    <button mat-button (click)="closeDrawer()" i18n="@@global.cancel">
      Cancel
    </button>
    <button
      mat-raised-button
      color="primary"
      (click)="submitForm(data.group, data.segmentationKey)"
      [disabled]="
        !categoryDescriptionForm.valid || isLoading || !isDescriptionUpdated
      "
      i18n="@@global.save"
    >
      Save
      <i
        *ngIf="isLoading"
        nz-icon
        nzType="sync"
        nzSpin
        class="u-marginLeft-8"
      ></i>
    </button>
  </div>
</div>
